
// Action Types for JSBridge navigation
export const ACTION_TYPES = {
    PO_PENDING_ACCEPTANCE_DETAIL: 'PO_PENDING_ACCEPTANCE_DETAIL',
    DD_PO_LIST_PAGE: 'DD_PO_LIST_PAGE',
    ALL_PO_NO_GRN_YET_PAGE: 'ALL_PO_NO_GRN_YET_PAGE',
    GRN_PENDING_CONFIRMATION_PAGE: 'GRN_PENDING_CONFIRMATION_PAGE',
};
